import QueryString from "qs"
import http from "../index"
import {
  apiBrowseTransaction,
  apiCreateDeposite,
  apiCreateWithdrawal,
  apiDetailTransaction,
  apiListTransaction,
  apiRefuseTransaction,
  apiListTransactionLeader,
  apiCreateDepositeLeader,
  apiDetailTransactionLeader,
  apiListTransactionStaff,
  apiGetBankAccInfo,
  apiCreateDepositeStaff,
  apiCreateWithdrawalStaff,
  apiUpdateBankInfo,
  apiBankingQr,
} from "./urls"

const createDeposite = body => http.post(apiCreateDeposite, body)
const createWithdrawal = body => http.post(apiCreateWithdrawal, body)
const getListTransaction = params => http.get(apiListTransaction, { params })
const detailTransaction = id => http.get(apiDetailTransaction(id))
const browseTransaction = id => http.put(apiBrowseTransaction(id))
const refuseTransaction = (id, body) => http.put(apiRefuseTransaction(id), body)

const getListTransactionLeader = params =>
  http.get(apiListTransactionLeader, { params })
const createDepositeLeader = body => http.post(apiCreateDepositeLeader, body)
const detailTransactionLeader = id => http.get(apiDetailTransactionLeader(id))
const listTransactionStaff = params =>
  http.get(apiListTransactionStaff, { params })
const getBankAccInfo = () => http.get(apiGetBankAccInfo)
const depositStaff = (body) => http.post(apiCreateDepositeStaff, body)
const withdrawalStaff =  (body) => http.post(apiCreateWithdrawalStaff, body)
const updateBankInfo = (body) => http.put(apiUpdateBankInfo, body)
const getBankingQr = (body) => http.post(apiBankingQr, body)

const TransactionManagement = {
  createDeposite,
  createWithdrawal,
  getListTransaction,
  detailTransaction,
  browseTransaction,
  refuseTransaction,
  getListTransactionLeader,
  createDepositeLeader,
  detailTransactionLeader,
  listTransactionStaff,
  depositStaff,
  withdrawalStaff,
  getBankAccInfo,
  updateBankInfo,
  getBankingQr
}
export default TransactionManagement
